module.exports = __webpack_public_path__ + "static/11-4acf7fd3eafbd5114002018100229c67.jpg";